import dayjs             from 'dayjs'
import relativeTime      from 'dayjs/plugin/relativeTime'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isBetween         from 'dayjs/plugin/isBetween'
import isSameOrBefore    from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter     from 'dayjs/plugin/isSameOrAfter'
import calendar          from 'dayjs/plugin/calendar'
import duration          from 'dayjs/plugin/duration'
import isToday           from 'dayjs/plugin/isToday'
import IsTomorrow        from 'dayjs/plugin/isTomorrow'
import IsYesterday       from 'dayjs/plugin/isYesterday'

dayjs.extend(isToday)
dayjs.extend(IsTomorrow)
dayjs.extend(IsYesterday)
dayjs.extend(isBetween)
dayjs.extend(duration)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
dayjs.extend(relativeTime)
dayjs.extend(calendar)
dayjs.extend(customParseFormat)

const DayjsPlugin = {
  install (Vue) {
    Object.defineProperties(Vue.prototype, {
      $dayjs: {
        get () {
          return dayjs
        }
      }
    })
    Vue.dayjs = dayjs
  }
}

export default DayjsPlugin

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(DayjsPlugin)
}
